import { Product } from '../types';
import { productPartnerBuilder } from './Partner';
import { priceBuilder } from './Price';

const defaults: Readonly<Product> = {
  available: true,
  code: 1,
  freeDomesticDelivery: false,
  images: [],
  links: [],
  isNew: false,
  number_of_reviews: 0,
  onSale: false,
  partner: productPartnerBuilder(),
  preSalePrices: [],
  price: priceBuilder(),
  product_rating: '',
  salePercentage: 0,
  title: '',
  isSponsored: false,
  isLoading: false,
  purchasable: true,
};

export const productBuilder = (product?: Partial<Product>): Readonly<Product> => ({
  ...defaults,
  ...product,
});
